import type { SoundDef } from './SoundManager.js';
import { fileDefs } from './soundFileDefs.js';
import { synthDefs } from './soundSynthDefs.js';

const source = (import.meta.env.VITE_AUDIO_SOURCE as string) ?? 'file';
const defs: Record<string, SoundDef> =
  source === 'synth' ? synthDefs : { ...synthDefs, ...fileDefs };

export function getSoundDef(soundId: string): SoundDef | undefined {
  return defs[soundId];
}

/** Maps sim event types to sound IDs. */
export const eventSoundMap: Record<string, string> = {
  'unit:combat': 'hit',
  'unit:moved': 'move',
  'unit:garrisoned': 'garrison',
  'unit:deployed': 'deploy',
  'city:damaged': 'city_damaged',
  'city:captured': 'captured',
  'city:attack_rejected': 'error',
  'depot:captured': 'captured',
  'building:started': 'button_click',
  'building:completed': 'build_done',
  'doctrine:invested': 'doctrine_spend',
  'hero:ability_activated': 'fanfare',
  'hero:ability_selected': 'panel_open',
  'hero:leveled': 'level_up',
  'legend:ability_activated': 'roar',
  'match:start': 'match_start',
  'match:victory': 'trumpets',
  'match:defeat': 'error',
  'mage:cast:healing_light': 'spell_healing_light',
  'mage:cast:teleport': 'spell_teleport',
  'mage:cast:divine_shield': 'spell_divine_shield',
  'mage:cast:summon_skeleton': 'spell_summon_skeleton',
  'mage:cast:lich_drain': 'spell_lich_drain',
  'faith:sacrifice': 'faith_sacrifice',
  'faith:crisis_triggered': 'faith_crisis',
  'faith:sanctified_pulse': 'sanctified_pulse',
  'espionage:assassin_success': 'assassin_success',
  'espionage:assassin_failure': 'assassin_failure',
  'espionage:sabotage_planted': 'sabotage_planted',
  'espionage:propaganda': 'propaganda',
  'espionage:intel': 'intel_gathered',
  'trade:convoy_departed': 'convoy_departed',
  'trade:convoy_arrived': 'convoy_arrived',
  'trade:convoy_intercepted': 'convoy_intercepted',
};
